//TODO consider splitting and moving to a separate folder

import { JsonProperty, parseJWTConverter } from '~app/shared/json-mapper';

export interface CodeChallenge {
  codeChallenge: string;
  codeChallengeMethod: 'S256' | 'plain';
}

export interface AuthUrlOptions extends CodeChallenge {
  loginHint?: string;
  prompt?: string;
  state: string;
  responseType?: 'code';
}

export interface LogoutOptions {
  state?: string;
}

export interface RedirectLoginOptions {
  loginHint?: string;
  prompt?: string;
  targetUrl?: string;
}

export interface OAuthTokenOptions {
  code?: string;
  codeVerifier?: string;
  refreshToken?: string;
  grantType?: string;
}

export interface Transaction {
  id: string;
  codeVerifier: string;
  targetUrl?: string;
  token?: OIDCTokenModel;
}

export interface RedirectCallbackHandlerOptions {
  code: string;
  state: string;
  error?: string;
  errorDescription?: string;
}

export enum TenantType {
  PRODUCER = 'producer',
  CONTRACTOR = 'contractor',
  INSPECTOR = 'inspector',
  STAFF = 'staff',
}

export class TenantModel {
  @JsonProperty('_id')
  id: string = void 0;
  name: string = void 0;
  type: TenantType = void 0;
  slug: string = void 0;
  products: string[] = [];
}

export class IdTokenModel {
  sub: string = void 0;
  email: string = void 0;
  products: string[] = void 0;
  @JsonProperty({ excludeToJson: true, type: TenantModel })
  tenants: TenantModel[] = [];
  zoneinfo = 'America/New_York';
  locale = 'en-US';
}

export class AccessTokenModel {
  sub: string = void 0;
  iat: number = void 0;
  exp: number = void 0;
  scope: string = void 0;
  @JsonProperty('client_id')
  clientId: string = void 0;
  iss: string = void 0;
  aud: string = void 0;
  @JsonProperty('organization_slug')
  organizationSlug?: string = void 0;
}

export class OIDCTokenModel {
  @JsonProperty('access_token')
  accessToken: string = void 0;
  @JsonProperty({ converter: parseJWTConverter(AccessTokenModel, 'access_token') })
  accessTokenDecoded: AccessTokenModel = void 0;
  @JsonProperty('id_token')
  idToken: string = void 0;
  @JsonProperty({ converter: parseJWTConverter(IdTokenModel, 'id_token') })
  idTokenDecoded: IdTokenModel = void 0;
  @JsonProperty('refresh_token')
  refreshToken: string = void 0;
  @JsonProperty('token_type')
  tokenType: string = void 0;
  @JsonProperty('expires_in')
  expiresIn: number = void 0; //seconds
  @JsonProperty({
    converter: {
      fromJson: (value, json) =>
        new Date(new Date().getTime() + json.expires_in * 1000).toISOString(),
    },
  })
  expiresAt: string = void 0;
}
